import { useEffect, useState } from "react";
import { api, formatError } from "./api";
import { toast } from "sonner";

let cfgPromise;
export function useRazorpay() {
  const [cfg, setCfg] = useState({ enabled: false });
  useEffect(() => {
    cfgPromise = cfgPromise || api.get("/razorpay/config").then((r) => r.data).catch(() => ({ enabled: false }));
    cfgPromise.then(setCfg);
  }, []);
  return cfg;
}

const loadScript = () => new Promise((resolve, reject) => {
  if (window.Razorpay) return resolve();
  const s = document.createElement("script");
  s.src = "https://checkout.razorpay.com/v1/checkout.js";
  s.onload = resolve; s.onerror = () => reject(new Error("Could not load Razorpay"));
  document.body.appendChild(s);
});
export const loadRazorpayScript = loadScript;

export async function payWithRazorpay(endpoint, payload, onDone) {
  try {
    await loadScript();
    const { data } = await api.post(endpoint, payload);
    const rzp = new window.Razorpay({
      key: data.key_id, order_id: data.order_id, amount: data.amount, currency: data.currency,
      name: data.name, description: data.description, prefill: data.prefill, theme: { color: "#4A0E17" },
      handler: async (res) => {
        try {
          await api.post("/razorpay/verify", res);
          window.location.href = `/payment/success?session_id=${data.order_id}`;
        } catch (e) { toast.error(formatError(e)); }
      },
      modal: { ondismiss: onDone },
    });
    rzp.on("payment.failed", (r) => { toast.error(r.error?.description || "Payment failed"); onDone(); });
    rzp.open();
  } catch (e) { toast.error(formatError(e)); onDone(); }
}
